export default "__VITE_ASSET__BOgEHF2R__"